/**
 * « Équipement / POI public » : le même choix que dans la palette, en haut de la fiche d'un
 * repère. Changer convertit le point (photos comprises, sans doublon), après confirmation.
 */
import { useTranslation } from 'react-i18next'
import type { PlaceAs } from './PoiPalette'

type Props = {
  value: PlaceAs
  disabled?: boolean
  onChange: (value: PlaceAs) => void
}

export function KindSwitch({ value, disabled, onChange }: Props) {
  const { t } = useTranslation('gestion')
  return (
    <div className="g-field">
      <span className="g-field__label">{t('carte.genre_point')}</span>
      <div className="g-segmented g-segmented--full" role="radiogroup" aria-label={t('carte.genre_point')}>
        {(['facility', 'poi'] as const).map((v) => (
          <button
            key={v}
            type="button"
            role="radio"
            aria-checked={value === v}
            disabled={disabled}
            className={`g-segmented__item${value === v ? ' g-segmented__item--active' : ''}`}
            onClick={() => v !== value && onChange(v)}
          >
            <span className={`mdi ${v === 'poi' ? 'mdi-earth' : 'mdi-domain'}`} aria-hidden /> {t(`carte.comme_${v}`)}
          </button>
        ))}
      </div>
      <span className="g-hint">{t(`carte.aide_comme_${value}`)}</span>
    </div>
  )
}
